import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../../util/app";
import AuthProvider from "../../../providers/Auth.Provider";
import AddButton from "../../../partials/Buttons/AddButton";
import LeaveListing from "../partials/Leave/LeaveListing";
import NewStaffLeave from "../partials/Leave/NewLeave";
import { useQuery, useMutation } from "react-apollo";
import { GET_STAFF_LEAVE, NEW_STAFF_LEAVE } from "../../../queries/staff-leave.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../partials/loading";
import { EVENT_TARGET, ACTION_TYPE } from "../../../event/model";
import { EventEmitter } from "../../../event/EventEmitter";
import { sendNotification } from "../../../sockette";

const StaffLeave = ({ id }) => {
    const title = "Annual Leave";
    const [newLeave, setNewLeave] = useState(false);

    const { loading, data, refetch } = useQuery(GET_STAFF_LEAVE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });

    const [createFunc, { loading: cLoading }] = useMutation(NEW_STAFF_LEAVE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.NewStaffLeave;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.STAFF_ANNUAL_LEAVE);
            setNewLeave(false);
        },
    });

    const { id: ref } = AuthProvider.authProvider.GetAuthenticatedStaff();

    EventEmitter.subscribe(EVENT_TARGET.STAFF_ANNUAL_LEAVE, () => refetch());

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>
            <div className="row">
                <div className="col-12">
                    <LoadingSpinner loading={loading || cLoading} bar={true} />
                </div>
                {id === ref && !newLeave && (
                    <div className="col-12 text-right fade-in">
                        <AddButton title="Request For Leave" onClick={() => setNewLeave(true)} />
                    </div>
                )}
                {!newLeave && data && (
                    <div className="col-12 fade-in">
                        <LeaveListing items={data.GetStaffLeaves.docs} />
                    </div>
                )}
                {newLeave && (
                    <div className="col-12 fade-in">
                        <NewStaffLeave
                            onCancel={() => setNewLeave(false)}
                            onSubmit={async (item) => {
                                await createFunc({ variables: { model: item } });
                            }}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default StaffLeave;
